import React, { useId } from 'react';

import { cn, Label, Select } from '@src/components/ui';


/**
 * Base select field — label above, native select, helper/error line below.
 * Receives RHF field props (value/onChange/onBlur/name/ref) plus
 * `error` (bool) and `helperText` from the generic form wrapper. Pass
 * `options` as `[{ value, label }]` to render `<option>`s, or pass
 * `<option>`s as `children` directly (used when `options` is omitted).
 */
const SelectField = React.forwardRef((props, ref) => {
  const {
    label,
    value = '',
    error = false,
    helperText = ' ',
    className,
    options = null,
    children,
    ...restProps
  } = props;

  const generatedId = useId();
  const id = restProps.id || generatedId;

  const content = options
    ? options.map((option) => (
      <option key={option.value} value={option.value}>
        {option.label}
      </option>
    ))
    : children;

  return (
    <div className={cn('flex flex-col gap-1.5', className)}>
      {label
        ? (
          <Label htmlFor={id}>{label}</Label>
        )
        : null}

      <Select ref={ref} id={id} value={value} invalid={error} {...restProps}>
        {content}
      </Select>

      <p className={cn('min-h-4 text-xs', error ? 'text-danger' : 'text-ink-subtle')}>
        {helperText}
      </p>
    </div>
  );
});

SelectField.displayName = 'SelectField';
export default SelectField;
